module.exports = "/images/ilustracion3.svg?68a957ff2f0e09a1714ee7d631da6a65";